<template>
  <div class="loader-body-init" v-if="type === 'init'">
    <div class="water"></div>
    <div style="width: 400px; margin-left: -400px; z-index: 100; text-align: center">
      <span>ЗАГРУЖАЮ ПРИЛОЖЕНИЕ</span>
    </div>
  </div>
  <div class="loader-body-init" v-if="type === 'error'">
    <div class="error"></div>
    <div style="width: 400px; margin-left: -400px; z-index: 100; text-align: center">
      <span>ОШИБКА ЗАГРУЗКИ</span>
    </div>
  </div>
  <div class="loader-body-send" v-if="type === 'send'">
    <div class="water"></div>
    <div style="width: 400px; margin-left: -400px; z-index: 100; text-align: center">
      <span>ОТПРАВЛЯЮ ОБРАЩЕНИЕ</span>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Loader",
  props: ['type']
}
</script>

<style scoped>
.loader-body-init {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loader-body-send {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.water {
  width: 400px;
  height: 400px;
  background-color: rgb(45,140,0);
  border-radius: 50%;
  position: relative;
  box-shadow: inset 0 0 30px 0 rgba(0,0,0,.5), 0 4px 10px 0 rgba(0,0,0,.5);
  overflow: hidden;
}

.error {
  width: 400px;
  height: 400px;
  background-color: rgb(255, 147, 147);
  border-radius: 50%;
  position: relative;
  box-shadow: inset 0 0 30px 0 rgba(0,0,0,.5), 0 4px 10px 0 rgba(0,0,0,.5);
  overflow: hidden;
}
.water:before, .water:after{
  content: '';
  position: absolute;
  width:400px;
  height: 400px;
  top:-150px;
  background-color: #fff;
}
.water:before{
  border-radius: 45%;
  background:rgba(255,255,255,.7);
  animation: wave 5s linear infinite;
}
.water:after{
  border-radius: 35%;
  background:rgba(255,255,255,.3);
  animation: wave 5s linear infinite;
}

.error:before, .water:after{
  content: '';
  position: absolute;
  width:400px;
  height: 400px;
  top:-150px;
  background-color: #fff;
}
.error:before{
  border-radius: 45%;
  background:rgba(255,255,255,.7);
  animation: wave 5s linear infinite;
}
.error:after{
  border-radius: 35%;
  background:rgba(255,255,255,.3);
  animation: wave 5s linear infinite;
}
@keyframes wave{
  0%{
    transform: rotate(0);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>